/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import { tracked } from "@glimmer/tracking";
import type { EmberChangeset } from "ember-changeset";
import { Changeset } from "ember-changeset";
import type { ModelListItem, ModelListComponentSignature } from "../model-list";
import ModelListComponent from "../model-list";

export interface ModalSignature extends ModelListComponentSignature {
  Blocks: {
    content: [ModelListItem];
    modalContent: [EmberChangeset];

    // Necessary for type declaration, but should not be used actually when using Modal style.
    default: [ModelListItem];
  };
}

/**
 * This component helps handle list of things in a component.
 * This helper provides the logic for handling lists:
 * - adding an item,
 * - deleting one,
 * - moving items (coming later).
 *
 * The model is usually a changeset.
 */
export default class ModelListWithModalComponent extends ModelListComponent<ModalSignature> {
  @tracked
  showModal = false;

  modalChangeset: EmberChangeset;

  constructor(owner, args) {
    super(owner, args);
    this.modalChangeset = Changeset({});
  }

  @action
  onModalValidated(): void {
    this.showModal = !this.showModal;
    this.modalChangeset.execute();
    this.addItemObject({ ...this.modalChangeset.data });
    /**
     * The rollback method of the changeset do not propagate changes.
     * So we have to set every key to undefined to propagate to the modal form
     */
    this.modalChangeset.changes.forEach(change =>
      this.modalChangeset.set(change.key, undefined)
    );
  }
}
